const videoInterviewBaseAPI = '/video-interview';

export const getAvailableVideoInterviewPath = () =>
  `${videoInterviewBaseAPI}/available`;
